/** Ordem visual das colunas do Kanban — a mesma sequência de `PRODUCT.md`, 3.3. */
export const ETAPAS_OPS = ['recebido', 'pintura', 'montagem', 'testes', 'embalagem', 'enviado'];
/** Etapa final — atingi-la conclui a OPS (`ops.concluida`, gatilho de comissão de técnico na Sprint 7). Terminal: nenhuma transição a partir daqui. */
export const ETAPA_CONCLUSAO = 'enviado';
//# sourceMappingURL=ops.js.map